<script>
export default {
  name: 'ComplianceItemBase',
  data(){
    return {
      slotOthers: false,
      iconSizeData: {
        'small': {
          'top': '0em', 'left': '-39.5px', 'height': '20px', 'width': '20px'
        },
        'large': {
          'top': '-0.5em', 'left': '-44px', 'height': '30px', 'width': '30px'
        }
      }
    }
  },
  props: {
    catStatus: {
      type: String,
      default: 'cat-default'
    },
    itemStatus: {
      type: String,
      default: 'item-default'
    },
    statusName: {
      type: String,
      default: ''
    }
  },

  computed: {
    categoryStatusClass(){
      let className = ''
      if(this.catStatus){
        className = this.catStatus
      }
      return className
    },
    itemStatusClass(){
      let className = ''
      if(this.itemStatus){
        className = this.itemStatus
      }
      return className
    }
  },
  mounted(){
    //this.slotOthers = !!this.$refs.others.innerHTML
  }
}
</script>
